import React from "react"

import Layout from "../components/layout/layout"
import Seo from "../components/seo"
import ShopItemImageCarousel from "../components/shop/shopItemImageCarousel"
import AddToBasketForm from "./addToBasketForm"
import ShopItemAttributesList from "../components/shop/shopItemAttributesList"

import usePreviewData from "../utils/usePreviewData"
import getItemImagesFromPrismicImageItems from "../utils/getItemImagesFromPrismicImageItems"

import * as ShopItemStyles from "../styles/shopItem.module.css"

const ShopItemPage = props => {
  const item = usePreviewData(props.pageContext.item)

  // * Add a check to prevent build from failing
  if (!item) {
    return null
  }

  const { shopImages, thumbImages } = getItemImagesFromPrismicImageItems(
    item.imageItems,
    "shopItem"
  )

  return (
    <>
      <Layout
        backButton
        pageTitle={item.title}
        pageTitleDescription={item.collection?.document?.data?.title}
      >
        <Seo
          title={item.title}
          description={item.description}
          keywords={[
            `women`,
            `design`,
            `collection`,
            `slow fashion`,
            `fashion`,
            `shop`,
            `buy`,
          ]}
        />
        <div
          className={[ShopItemStyles.container, "full-page-bleed"].join(" ")}
        >
          <ShopItemImageCarousel
            images={shopImages}
            thumbImages={thumbImages}
          />

          <div className={ShopItemStyles.detailsContainer}>
            <h2>
              {item.title}
              {!item.sold_out && (
                <span className={ShopItemStyles.price}> €{item.price}</span>
              )}
            </h2>

            <ShopItemAttributesList item={item} />

            <div className={ShopItemStyles.addToBasketWrapper}>
              <AddToBasketForm
                item={{
                  title: item.title,
                  uid: item.uid,
                  sizes: item.sizes,
                  images: thumbImages,
                  price: item.price,
                  shopLink: item.shopLink,
                  _stripe_product_details: item._stripe_product_details,
                  sold_out: item.sold_out,
                }}
              />
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default ShopItemPage
